import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Button from "../../AdminModule/Dashboard/AdminDashboard/Button";
import ReactStars from "react-rating-stars-component";
import "./styles.scss";
import { makeStyles } from "@material-ui/core/styles";
import TextareaField from "../TextAreaField";
import {
  postMentorSessionMinutes,
  detailsGroupSession,
} from "../../AdminModule/Dashboard/MentorDashboard/dependencies/action";
const useStyles = makeStyles((theme) => ({
  input: {
    backgroundColor: "white",
    padding: "0.5px 0px",
  },
}));
function SessionGroupFeedbackModal(props) {
  let loggedIn = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const { detailsGroupSession, detailsGroupSessionData,fromPage } = props;
  const [hideButtons, setHideButtons] = useState(true);
  const hoursData = [{}];
  const [ratingData, setRatingData] = useState(0);
  const [discussonSummary, setDiscussonSummary] = useState("");
  const [fileData, setFileData] = useState();
  const [sessionHours, setSessionHours] = useState(0);
  const classes = useStyles();
  const [wordCounter, setWordCounter] = useState(0);
  const [errorMessagePurpose, setErrorMessagePurpose] = useState(
    "*Please Enter the purpose"
  );
  const [showError, setShowError] = useState(false);
  const [errorVisible, SetErrorVisible] = useState(false);
  const [errorVisible7, SetErrorVisible7] = useState(false);
  const [sessionHoursError, setSessionHoursError] = useState(false);
  const [venueCounter, setVenueCounter] = useState(0);
  const [directionsCounter, setDirectionCounter] = useState(0);
  const [addressCounter, setAddressCounter] = useState(0);
  const [phNoCounter, setPhNoounter] = useState(0);
  const customStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "white",
      minHeight: "45px",
      color: "#333",
      maxwidth: "10rem",
      fontSize: "18px",
    }),
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: "black",
      };
    },
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected
          ? "#b499c7"
          : isFocused
          ? "#e4d7ee"
          : "white",
        color: isSelected ? "white" : "black",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
      fontSize: "14px",
    }),
  };
  hoursData.push(
    {
      value: "0",
      label: "0.5",
    },
    { value: "1", label: "1" },
    { value: "2", label: "1.5" },
    { value: "3", label: "2" },
    { value: "4", label: "2.5" },
    { value: "5", label: "3" },
    { value: "6", label: "3.5" },
    { value: "7", label: "4" },
    { value: "8", label: "4.5" },
    { value: "9", label: "5" },
    { value: "10", label: "5.5" },
    { value: "11", label: "6" }
  );

  const handleClose = () => {
    props.setModalVisibility(false);
    setHideButtons(true);
    setSessionHours(0);
    setRatingData(0);
    setDiscussonSummary("");
    setFileData();
  };

  const ratingChanged = (newRating) => {
    setRatingData(newRating);
  };

  const testWordLimit = (data) => {
    let value =
      data?.length === 0
        ? 0
        : data
            ?.replace(/(^\s*)|(\s*$)/gi, "")
            ?.replace(/[ ]{2,}/gi, " ")
            ?.split(" ")?.length;
    if (value == 250) {
      setErrorMessagePurpose("Exceeds word limit reached");
      SetErrorVisible7(true);
    } else if (value < 250 && value > 0) {
      SetErrorVisible7(false);
      setErrorMessagePurpose("*Please Enter the purpose");
    } else if (value == 0) {
      SetErrorVisible7(true);
    } else if (value == 251) {
      setWordCounter(250);
      return value;
    }
    setWordCounter(value);
    return value;
  };
  const handleSubmit = () => {
    const formData = new FormData();
    if (
      sessionHours > 0 &&
      sessionHours !== "" &&
      attendesCount !== "" &&
      attendesCount > 0 &&
      discussonSummary !== "" &&
      ratingData > 0
    ) {
      setShowError(false);
      let params = {
        cohortGroupSessionId:
          props?.cohortGroupId !== "" &&
          props?.cohortGroupId !== null &&
          props?.cohortGroupId !== undefined
            ? props?.cohortGroupId
            : props?.modalData?.cohortGroupSessionId,
        sessionDuration: sessionHours,
        noOfAttendees: attendesCount,
        sessionNotes: discussonSummary,
        sessionRating: ratingData,
        addedBy: loggedIn?.id,
        sessionFormat: props?.modalData?.sessionFormat,
      };
      formData.append("application", JSON.stringify(params));
      formData.append("uploadSupportingFile", fileData?.uploadResume);
      props?.postFeedBack(formData);
      let params2 = {
        cohortGroupSessionId:
          props?.cohortGroupId !== "" &&
          props?.cohortGroupId !== null &&
          props?.cohortGroupId !== undefined
            ? props?.cohortGroupId
            : props?.modalData?.cohortGroupSessionId,
        sessionStatus:
          props?.modalData?.sessionStatus === "AUTOCOMPLETED"
            ? "AUTOCOMPLETED"
            : "COMPLETED",
        userId: loggedIn?.id,
      };
      if (props?.fromPage && props?.fromPage == "groupPage" && loggedIn?.id == props?.modalData?.cohortApplication?.mentorId )
      {
      props?.updateStatus(params2);
      }
      setTimeout(() => {
        props?.setModalVisibility(false);
        props?.parentData(true);
      }, 750);
    } else {
      setShowError(true);
    }
  };

  const firstExample = {
    size: 35,
    count: 5,
    isHalf: false,
    value: 0,
    color: "lightgray",

    activeColor: "orange",
    onChange: (newValue) => {
      setRatingData(newValue);
    },
  };
  const secondExample = {
    size: 35,
    count: 5,
    isHalf: false,
    value:
      props?.viewMode && props?.viewMode === true
        ? props?.modalData?.sessionRating
        : 0,
    color: "lightgray",

    activeColor: "orange",
    onChange: (newValue) => {
      setRatingData(newValue);
    },
  };

  const [attendesCount, setAttendesCount] = useState("");
  useEffect(() => {
    if(props?.modalData?.actualDuration !== undefined && props?.modalData?.actualDuration !== null && props?.modalData?.actualDuration !== 0)
    {
      setSessionHours(props?.modalData?.actualDuration);
    }
    else {
      setSessionHours(props?.modalData?.sessionDuration);
    }
    setAttendesCount(props?.modalData?.totalParticipant);
  }, []);
  const clickonFileinput = (event) => {
    event.preventDefault();
    let element = document.getElementById("fileUpload-resume");
    element.click();
  };
  const handleInputChange = (e) => {
    setFileData((user) => {
      return { ...user, [e.target.name]: e.target.files[0] };
    });
    const newFormData = {
      ...fileData,
      [e.target.name]: e.target.files[0],
    };
  };
  const removeFile = (fileType) => {
    if (fileType === "uploadResume") {
      setFileData((user) => {
        return { ...user, ["uploadResume"]: null };
      });
    }
  };
  useEffect(() => {
    // getSessionDetails(item?.cohortGroupSessionId);
    let params = {
      cohortGroupSessionId: props?.modalData?.cohortGroupSessionId,
      userId: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,
    };
    detailsGroupSession(params);
  }, []);
  useEffect(() => {
    if (
      detailsGroupSessionData !== undefined &&
      detailsGroupSession !== null &&
      detailsGroupSessionData !== ""
    ) {
      if (
        detailsGroupSessionData?.venue !== "" &&
        detailsGroupSessionData?.venue !== null
      ) {
        setVenueCounter(1);
      }
      if (
        detailsGroupSessionData?.address !== "" &&
        detailsGroupSessionData?.address !== null
      ) {
        setAddressCounter(1);
      }
      if (
        detailsGroupSessionData?.phoneNo !== "" &&
        detailsGroupSessionData?.phoneNo !== null
      ) {
        setPhNoounter(1);
      }
      if (
        detailsGroupSessionData?.directions !== "" &&
        detailsGroupSessionData?.directions !== null
      ) {
        setDirectionCounter(1);
      }
    }
  }, [detailsGroupSessionData]);
  return (
    <>
      <div className="modal-dialog modal-dialog-centered">
        <Modal
          size="lg"
          show={props.modalVisibility}
          onHide={() => {
            props.setModalVisibility(false);
            setSessionHours(0);
            setRatingData(0);
            setDiscussonSummary("");
            setFileData();
          }}
          aria-labelledby="example-modal-sizes-title-lg"
          style={{ borderRadius: "7px" }}
        >
          <Modal.Header className="d-flex ">
            <Modal.Title className="sessionMinutesHeading">
              SESSION NOTES
            </Modal.Title>
            <div className="newuserTooltip">
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleClose}
              />
              <span
                className="tooltiptext  close-window"
                style={{ left: "-130px", top: "2px", width: "130px" }}
              >
                Close Window
              </span>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="session-detailsModal">
              {props?.viewMode && props?.viewMode === true ? (
                <div className="feedback-session2">
                  <div className="row pb-4 mt-2">
                    <div className="col col-lg-1 col-md-1 col-sm-12 col-2 numdata d-flex justify-content-center">
                      1
                    </div>
                    <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                      SESSION DURATION
                    </div>
                    <div className="col col-lg-7 col-md-6 col-sm-12  col-12 fixmodalmargindata">
                      {props?.modalData?.sessionDuration + " hrs"}
                    </div>
                  </div>
                  <div className="row pb-4 ">
                    <div className="col col-lg-1 col-md-1 col-sm-2 col-2 d-flex justify-content-center">
                      2
                    </div>
                    <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                      SESSION MODE
                    </div>
                    <div className="fileUpload2 col col-lg-7 col-md-6 col-sm-12 fixmodalmargindata">
                      <div className="newDataFields">
                        {props?.modalData?.sessionFormat === "ONLINE"
                          ? "On MAARG Platform"
                          : "Other"}
                      </div>
                    </div>
                  </div>
                  <div className="row pb-4 ">
                    <div className="col col-lg-1 col-md-1 col-sm-2 col-2 d-flex justify-content-center">
                      3
                    </div>
                    <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                      NO. OF ATTENDEES
                    </div>
                    <div className="fileUpload2 col col-lg-7 col-md-6 col-sm-12 fixmodalmargindata">
                      <div className="newDataFields">
                        {props?.modalData?.noOfAttendees}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col col-lg-1 col-md-1 col-sm-2 col-2 d-flex justify-content-center">
                      4
                    </div>
                    <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                      SESSION NOTES
                    </div>
                    <div
                      className="col col-lg-7 col-md-6 col-sm-12  col-12 newDataFields2"
                    >
                      {props?.modalData?.sessionNotes}
                      {/* <TextareaField
                        id="purpose"
                        variant="outlined"
                        placeholder="Total number of attendees."
                        fullWidth
                        margin="normal"
                        style={{ backgroundColor: "white",color:"red" }}
                        name="purpose"
                        InputProps={{ className: classes.input }}
                        value={props?.modalData?.sessionNotes}
                        rows={5}
                      /> */}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col col-lg-1 col-md-1 col-sm-2 col-2 d-flex justify-content-center">
                      5
                    </div>
                    <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding">
                      SESSION RATING
                    </div>
                    <div className="col col-lg-7 col-md-6 col-sm-12  col-12 starsDiv">
                      <ReactStars
                        {...secondExample}
                        half
                        onChange={ratingChanged}
                        edit={false}
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col col-lg-1 col-md-1 col-sm-2 col-2 d-flex justify-content-center">
                      6
                    </div>
                    <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                       DOCUMENT
                    </div>
                    <div className="fileUpload2 col col-lg-7 col-md-6 col-sm-12 ">
                      {props?.modalData?.attachedDoc !== null ? (
                        <td className="session-answer col-md-6 col-sm-6 col-1 ">
                          <div className="modalButtonDoc newuserTooltip viiwwdoc">
                            <a
                              text="View Document"
                              target="_blank"
                              href={props?.modalData?.attachedDoc}
                            >
                              View Document
                            </a>
                            <span
                              className="tooltiptext   tooltip-bottom"
                              style={{ left: "75px", top: "50px" }}
                            >
                              View Document
                            </span>
                          </div>
                        </td>
                      ) : (
                        <td className="col-md-6 col-sm-6 col-1 oterdocumentciew newDataFields">
                          NA
                        </td>
                      )}
                    </div>
                  </div>
                  {detailsGroupSessionData !== undefined &&
                  detailsGroupSessionData !== null &&
                  detailsGroupSessionData?.venue !== "" &&
                  detailsGroupSessionData?.venue !== null ? (
                    <div className="row mt-2">
                      <div className="col col-lg-1 col-md-1 col-sm-2 col-2 d-flex justify-content-center">
                        {venueCounter + 6}
                      </div>
                      <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                        VENUE
                      </div>
                      <div className="fileUpload2 col col-lg-7 col-md-6 col-sm-12 ">
                        <td
                          className="session-answer col-md-6 col-sm-6 col-1 newDataFields"
                          style={{ display: "contents" }}
                        >
                          {detailsGroupSessionData?.venue}
                        </td>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {detailsGroupSessionData !== undefined &&
                  detailsGroupSessionData !== null &&
                  detailsGroupSessionData?.address !== "" &&
                  detailsGroupSessionData?.address !== null ? (
                    <div className="row mt-2">
                      <div className="col col-lg-1 col-md-1 col-sm-2 col-2 d-flex justify-content-center">
                        {venueCounter + 6 + addressCounter}
                      </div>
                      <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                        ADDRESS
                      </div>
                      <div className="fileUpload2 col col-lg-7 col-md-6 col-sm-12">
                        <td className="session-answer col-md-6 col-sm-6 col-1 ">
                          <div
                            className="col-md-6 col-sm-6 col-1 oterdocumentciew newDataFields"
                            style={{ display: "contents" }}
                          >
                            {detailsGroupSessionData?.address}
                          </div>
                        </td>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {detailsGroupSessionData !== undefined &&
                  detailsGroupSessionData !== null &&
                  detailsGroupSessionData?.phoneNo !== "" &&
                  detailsGroupSessionData?.phoneNo !== null ? (
                    <div className="row mt-2">
                      <div className="col col-lg-1 col-md-1 col-sm-2 col-2 d-flex justify-content-center">
                        {venueCounter + 6 + addressCounter + phNoCounter}
                      </div>
                      <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                        CONTACT NUMBER
                      </div>
                      <div className="fileUpload2 col col-lg-7 col-md-6 col-sm-12">
                        <td className="session-answer col-md-6 col-sm-6 col-1 ">
                          <div className="newDataFields">
                            {"+"}
                            {detailsGroupSessionData?.phoneNo}
                          </div>
                        </td>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {detailsGroupSessionData !== undefined &&
                  detailsGroupSessionData !== null &&
                  detailsGroupSessionData?.directions !== "" &&
                  detailsGroupSessionData?.directions !== null ? (
                    <div className="row mt-2">
                      <div className="col col-lg-1 col-md-1 col-sm-2 col-2 d-flex justify-content-center">
                        {venueCounter +
                          6 +
                          addressCounter +
                          phNoCounter +
                          directionsCounter}
                      </div>
                      <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                        DIRECTIONS
                      </div>
                      <div className="fileUpload2 col col-lg-7 col-md-6 col-sm-12">
                        <td className="session-answer col-md-6 col-sm-6 col-1 ">
                          <div className="modalButtonDoc2 newuserTooltip viiwwdoc top-btn">
                            <a
                              text="View Document"
                              target="_blank"
                              href={detailsGroupSessionData?.directions}
                            >
                              VIEW DIRECTIONS
                            </a>
                            <span
                              className="tooltiptext   tooltip-bottom"
                              style={{ left: "75px", top: "50px" }}
                            >
                              Click to view directions to the venue.
                            </span>
                          </div>
                        </td>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <div className="feedback-session2">
                  <div className="row pb-4 mt-2">
                    <div className="col col-lg-1 col-md-1 col-sm-12 col-2 numdata d-flex justify-content-center">
                      1
                    </div>
                    <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                      SESSION DURATION*
                    </div>
                    {
                      loggedIn?.id == props?.modalData?.cohortApplication?.mentorId ? 
                      <div className="col col-lg-7 col-md-6 col-sm-12  col-12 fixmodalmargindata">
                      {props?.modalData?.sessionDuration !== "" &&
                        props?.modalData?.sessionDuration !== undefined && (
                          <>
                            <div className="row d-flexmodalButton39">
                              <div
                                style={{
                                  textAlign: "left",
                                  fontFamily: "Montserrat",
                                }}
                                className="col-9"
                              >
                                <Select
                                  options={hoursData}
                                  styles={customStyles}
                                  placeholder={sessionHours}
                                  onChange={(e) => {
                                    setSessionHours(e.label);
                                    setSessionHoursError(false);
                                  }}
                                  value={sessionHours}
                                />
                              </div>
                            </div>
                          </>
                        )}
                      {sessionHoursError && (
                        <div className="login-error-msg errorMessageFix">
                          Please confirm the session hours
                        </div>
                      )}
                      {errorVisible && (
                        <div className="login-error-msg errorMessageFix">
                          Please enter all details*
                        </div>
                      )}
                    </div>
                      :
                      <div className="fileUpload2 col col-lg-7 col-md-6 col-sm-12 fixmodalmargindata">
                      <div className="newDataFields">
                        {props?.modalData?.sessionDuration}
                      </div>
                    </div>
                    }
                    
                  </div>
                  <div className="row pb-4 ">
                    <div className="col col-lg-1 col-md-1 col-sm-2 col-2 d-flex justify-content-center">
                      2
                    </div>
                    <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                      SESSION MODE
                    </div>
                    <div className="fileUpload2 col col-lg-7 col-md-6 col-sm-12 fixmodalmargindata">
                      <div className="newDataFields">
                        {props?.modalData?.sessionFormat === "ONLINE"
                          ? "On MAARG Platform"
                          : "OTHER PLATFORM"}
                      </div>
                    </div>
                  </div>
                  <div className="row pb-4 ">
                    <div className="col col-lg-1 col-md-1 col-sm-2 col-2 d-flex justify-content-center">
                      3
                    </div>
                    <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                      NO. OF ATTENDEES*
                    </div>
                    {
                      loggedIn?.id == props?.modalData?.cohortApplication?.mentorId ? 
                      <div
                      style={{ textAlign: "right" }}
                      className="col col-lg-7 col-md-6 col-sm-12  col-12 discussionSummaryBox fixmodalmargindata"
                    >
                      <TextareaField
                        id="purpose"
                        variant="outlined"
                        placeholder="Total number of attendees."
                        fullWidth
                        margin="normal"
                        style={{ backgroundColor: "white" }}
                        name="purpose"
                        InputProps={{ className: classes.input }}
                        value={attendesCount}
                        onChange={(e) => {
                          const regex = /^[0-9\b]+$/;
                          if (
                            e.target.value === "" ||
                            regex.test(e.target.value)
                          ) {
                            setAttendesCount(e.target.value);
                          }
                        }}
                      />

                      {/* {errorVisible7 && (
                        <div className="login-error-msg mt-2">
                          {errorMessagePurpose}
                        </div>
                      )} */}
                    </div> :   
                    <div className="fileUpload2 col col-lg-7 col-md-6 col-sm-12 fixmodalmargindata">
                      <div className="newDataFields">
                        {props?.modalData?.totalParticipant}
                      </div>
                    </div>
                    }
                 
                    
                    {/* <div className="fileUpload2 col col-lg-7 col-md-6 col-sm-12 fixmodalmargindata">
                    <div>
                      {props?.modalData?.sessionFormat === "ONLINE"
                      || (props?.fromPage && props?.fromPage === "invitationPage") 
                       ? (
                        <div className="col col-lg-7 col-md-6 col-sm-12 ">
                          {props?.modalData?.totalParticipant}
                        </div>
                      ) : (
                        <Grid item container spacing={2} xs={8}>
                          <Grid item xs={8}>
                            <InputBase
                              style={{
                                border: "1px solid rgba(0,0,0,0.3)",
                                padding: "10px",
                                fontFamily: "Montserrat",
                                borderRadius: "3px",
                                fontSize: "18px",
                              }}
                              rows={1}
                              maxRows={5}
                              defaultValue={props?.modalData?.totalParticipant}
                              onChange={(e) => {
                               setAttendesCount(e.target.value);
                              }}
                            />
                           
                          </Grid>
                        </Grid>
                      )}
                    </div>
                  </div> */}
                  </div>
                  <div className="row">
                    <div className="col col-lg-1 col-md-1 col-sm-2 col-2 d-flex justify-content-center">
                      4
                    </div>
                    <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                      SESSION NOTES*
                    </div>
                    <div
                      style={{ textAlign: "right" }}
                      className="col col-lg-7 col-md-6 col-sm-12  col-12 discussionSummaryBox fixmodalmargindata"
                    >
                      <TextareaField
                        id="purpose"
                        variant="outlined"
                        placeholder="Describe in maximum 250 words"
                        fullWidth
                        margin="normal"
                        style={{ backgroundColor: "white" }}
                        name="purpose"
                        rows={5}
                        InputProps={{ className: classes.input }}
                        value={discussonSummary}
                        onChange={(e) => {
                          if (testWordLimit(e.target.value) < 251) {
                            setDiscussonSummary(e.target.value);
                          }
                        }}
                      />
                      <div className="wordCounter">
                        Word Count: {wordCounter} / 250
                      </div>

                      {errorVisible7 && (
                        <div className="login-error-msg mt-2">
                          {errorMessagePurpose}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col col-lg-1 col-md-1 col-sm-2 col-2 d-flex justify-content-center">
                      5
                    </div>
                    <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding">
                      RATE THE SESSION*
                    </div>
                    <div className="col col-lg-7 col-md-6 col-sm-12  col-12 starsDiv">
                      <ReactStars
                        {...firstExample}
                        half
                        onChange={ratingChanged}
                      />
                      {showError && (
                        <div className="login-error-msg mt-2">
                          Please fill all Parameters
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col col-lg-1 col-md-1 col-sm-2 col-12 d-flex justify-content-center">
                      6
                    </div>
                    <div className="col col-lg-4 col-md-5 col-sm-10 col-12 feedback-headdding ">
                      UPLOAD DOCUMENT
                    </div>
                    <div className="fileUpload2 col col-lg-7 col-md-6 col-sm-12 ">
                      <div>
                        <div className="newuserTooltip">
                          <div className="d-flex">
                            <div className="top-btn">
                              <button
                                onClick={clickonFileinput}
                                className="newUploadBtn"
                              >
                                CLICK TO UPLOAD
                              </button>
                              <span
                                className="tooltiptext   tooltip-bottom"
                                style={{
                                  top: "47px",
                                  left: "89px",
                                  width: "auto",
                                }}
                              >
                                Upload Document
                              </span>
                            </div>
                            <div style={{ marginLeft: "1rem" }}>
                              {fileData && fileData?.uploadResume !== null && (
                                <div style={{ marginBottom: "50px" }}>
                                  <div
                                    className="file-name"
                                    style={{ float: "left" }}
                                  >
                                    {fileData?.uploadResume?.name?.length > 20
                                      ? fileData?.uploadResume?.name.substring(
                                          0,
                                          20
                                        ) + "..."
                                      : fileData?.uploadResume?.name}
                                    <span
                                      style={{ marginLeft: "10px" }}
                                      onClick={() => removeFile("uploadResume")}
                                    >
                                      {" "}
                                      X{" "}
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <p
                          className="wordCounter"
                          style={{ marginTop: "10px" }}
                        >
                          <span>
                            Supported file format PDF,JPEG,PNG,DOCX,XLS only
                            upto 10MB
                          </span>
                        </p>
                        <div className="fileupload-resume-startup">
                          <input
                            className="resume-upload"
                            type="file"
                            id="fileUpload-resume"
                            required
                            name="uploadResume"
                            onChange={handleInputChange}
                            accept=".jpg, .jpeg, .png,.xls,.pdf,.xlsx,.docx"
                            style={{ display: "none" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {detailsGroupSessionData !== undefined &&
                  detailsGroupSessionData !== null &&
                  detailsGroupSessionData?.venue !== "" &&
                  detailsGroupSessionData?.venue !== null ? (
                    <div className="row mt-2">
                      <div className="col col-lg-1 col-md-1 col-sm-2 col-2 d-flex justify-content-center">
                        {venueCounter + 6}
                      </div>
                      <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                        VENUE
                      </div>
                      <div className="fileUpload2 col col-lg-7 col-md-6 col-sm-12 ">
                        <td
                          className="session-answer col-md-6 col-sm-6 col-1 newDataFields"
                          style={{ display: "contents" }}
                        >
                          {detailsGroupSessionData?.venue}
                        </td>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}{" "}
                  {detailsGroupSessionData !== undefined &&
                  detailsGroupSessionData !== null &&
                  detailsGroupSessionData?.address !== "" &&
                  detailsGroupSessionData?.address !== null ? (
                    <div className="row mt-2">
                      <div className="col col-lg-1 col-md-1 col-sm-2 col-2 d-flex justify-content-center">
                        {venueCounter + 6 + addressCounter}
                      </div>
                      <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                        ADDRESS
                      </div>
                      <div className="fileUpload2 col col-lg-7 col-md-6 col-sm-12">
                        <td className="session-answer col-md-6 col-sm-6 col-1 ">
                          <div
                            className="col-md-6 col-sm-6 col-1 oterdocumentciew newDataFields"
                            style={{ display: "contents" }}
                          >
                            {detailsGroupSessionData?.address}
                          </div>
                        </td>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {detailsGroupSessionData !== undefined &&
                  detailsGroupSessionData !== null &&
                  detailsGroupSessionData?.phoneNo !== "" &&
                  detailsGroupSessionData?.phoneNo !== null ? (
                    <div className="row mt-2">
                      <div className="col col-lg-1 col-md-1 col-sm-2 col-2 d-flex justify-content-center">
                        {venueCounter + 6 + addressCounter + phNoCounter}
                      </div>
                      <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                        CONTACT NUMBER
                      </div>
                      <div className="fileUpload2 col col-lg-7 col-md-6 col-sm-12">
                        <td className="session-answer col-md-6 col-sm-6 col-1 newDataFields">
                          <div>
                            {"+"}
                            {detailsGroupSessionData?.phoneNo}
                          </div>
                        </td>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {detailsGroupSessionData !== undefined &&
                  detailsGroupSessionData !== null &&
                  detailsGroupSessionData?.directions !== "" &&
                  detailsGroupSessionData?.directions !== null ? (
                    <div className="row mt-2">
                      <div className="col col-lg-1 col-md-1 col-sm-2 col-2 d-flex justify-content-center">
                        {venueCounter +
                          6 +
                          addressCounter +
                          phNoCounter +
                          directionsCounter}
                      </div>
                      <div className="col col-lg-4 col-md-5 col-sm-10 col-10 feedback-headdding ">
                        DIRECTIONS
                      </div>
                      <div className="fileUpload2 col col-lg-7 col-md-6 col-sm-12">
                        <td className="session-answer col-md-6 col-sm-6 col-1 ">
                          <div className="modalButtonDoc2 newuserTooltip viiwwdoc top-btn">
                            <a
                              text="View Document"
                              target="_blank"
                              href={detailsGroupSessionData?.directions}
                            >
                              VIEW DIRECTIONS
                            </a>
                            <span
                              className="tooltiptext   tooltip-bottom"
                              style={{ left: "75px", top: "50px" }}
                            >
                              Click to view directions to the venue.
                            </span>
                          </div>
                        </td>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center feedBackFooterFix2">
            {props?.viewMode === true ? (
              <div className="d-flex justify-center feedBackFooterFix">
                <div>
                  <Button
                    onClick={handleClose}
                    text="CLOSE"
                    className="modalButton3 doc-upload"
                  ></Button>
                </div>
              </div>
            ) : (
              <div className="d-flex justify-between feedBackFooterFix">
                <div>
                  <Button
                    onClick={handleClose}
                    text="BACK"
                    className="modalButton3 doc-upload"
                  ></Button>
                </div>

                <div>
                  <Button
                    onClick={handleSubmit}
                    text="SAVE & SUBMIT"
                    className="modalButton3 doc-uploadnext"
                  ></Button>
                </div>
              </div>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    detailsGroupSessionData: state.MentorReducer.detailsCohortGroupSession.data,
  };
};

export default connect(mapStateToProps, {
  postMentorSessionMinutes,
  detailsGroupSession,
})(withRouter(SessionGroupFeedbackModal));
